<div *ngIf="loading; else content">
  <!-- Skeleton loading state -->
  <div class="heading-container">
    <div class="heading-shimmer">
  
    </div>
  </div>
  <div class="skeleton-loading">
    <div class="calendar-shimmer"></div>
    <div class="calendar-shimmer"></div>
    <div class="calendar-shimmer"></div>
    <div class="calendar-shimmer"></div>
    <div class="calendar-shimmer"></div>
    <div class="calendar-shimmer"></div>
    <div class="calendar-shimmer"></div>
    <div class="calendar-shimmer"></div>
    <div class="calendar-shimmer"></div>
    <div class="calendar-shimmer"></div>
    <div class="calendar-shimmer"></div>
    <div class="calendar-shimmer"></div>
    <div class="calendar-shimmer"></div>
    <div class="calendar-shimmer"></div>
    <div class="calendar-shimmer"></div>
    <div class="calendar-shimmer"></div>
    <div class="calendar-shimmer"></div>
    <div class="calendar-shimmer"></div>
    <div class="calendar-shimmer"></div>
    <div class="calendar-shimmer"></div>
    <div class="calendar-shimmer"></div>
    <div class="calendar-shimmer"></div>
    <div class="calendar-shimmer"></div>
    <div class="calendar-shimmer"></div>
    <!-- Repeat the shimmer divs as needed for your design -->
  </div>
</div>

<ng-template #content>
    <div class="heading">
      <button mat-raised-button (click)="lastMonth()">
        Mes previo
      </button>
      <h2>{{ viewDate | date:'MMMM yyyy':'es' }}</h2>
      <button mat-raised-button (click)="nextMonth()">
        Mes próximo
      </button>
    </div>
 
    <mwl-calendar-month-view
      [cellTemplate]="customCellTemplate"
      [viewDate]="viewDate"
      [events]="calendarEvents"
      style="cursor: pointer;"
      (dayClicked)="onDayClick($event.day.date)"
      (eventClicked)="onEventClick($event.event); "
    >

  </mwl-calendar-month-view>
  
  <ng-template #customCellTemplate let-day="day">
 
    <div class="cell" [matBadge]="day.events.length"  matBadgeColor="warn" matBadgePosition="before"
    [ngClass]="{'out-of-month': !isCurrentMonth(day)}">
      <div class="day-number">
        {{ day.date | date:'d' }}
      </div>
      <div *ngFor="let e of day.events" [style.background-color]="getLabelBackgroundColor(e)" 
      class="customEvent" (click)="onEventClick(e)">
        {{e.title}}
      </div>
    </div>
  </ng-template>
</ng-template>
